import { useState } from "react";
import { MultiSelectChangeEvent } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";

import { useAppDispatch } from "store/store";
import { inputLocks, inputShared, labelTipologia } from "_constants";
import { setTypeProject } from "store/slicer/GestioneProjectsSlice";

export const InputProjectType = () => {
  const typeList = [
    { name: inputLocks, code: "PRIVATE" },
    { name: inputShared, code: "SHARED" },
  ];
  const [selectedType, setSelectedType] = useState<string[] | null>(null);

  const dispatch = useAppDispatch();

  const onChangeValue = (event: MultiSelectChangeEvent) => {
    setSelectedType(event.value);
    dispatch(setTypeProject(event.value?.code ?? null));
  };

  return (
    <Dropdown
      value={selectedType}
      onChange={onChangeValue}
      options={typeList ?? []}
      optionLabel="name"
      placeholder={labelTipologia}
      showClear={true}
      panelClassName="dropdown-custom"
    />
  );
};
